import { useState } from 'react';

/** Date du jour au format AAAA-MM-JJ, dans le fuseau de l'appareil. */
export const aujourdhuiIso = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const decaler = (iso, n) => { const d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const cle = e => `${e.date || ''} ${e.heure || ''}`;

/** Sépare une liste d'événements : à venir (du plus proche au plus lointain), passés (du plus récent au plus ancien). */
export function separer(elements, jour = aujourdhuiIso()) {
  const aVenir = elements.filter(e => (e.date || '') >= jour).sort((a, b) => cle(a).localeCompare(cle(b)));
  const passes = elements.filter(e => (e.date || '') < jour).sort((a, b) => cle(b).localeCompare(cle(a)));
  return { aVenir, passes };
}

/**
 * « À venir » d'abord, le plus proche en tête ; puis « Passés », les derniers jours visibles,
 * le reste derrière « Voir les plus anciens ». Rien n'est supprimé : c'est l'affichage seulement.
 */
export default function ListeChronologique({ elements, rendre, vide = 'Rien pour le moment', joursRecents = 14 }) {
  const [tout, setTout] = useState(false);
  const jour = aujourdhuiIso();
  const { aVenir, passes } = separer(elements, jour);
  const limite = decaler(jour, -joursRecents);
  const recents = passes.filter(e => (e.date || '') >= limite), anciens = passes.filter(e => (e.date || '') < limite);
  const titre = t => <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.5, textTransform: 'uppercase', color: 'var(--muted, #8b949e)', margin: '14px 0 8px' }}>{t}</div>;
  if (!elements.length) return <div className="card" style={{ textAlign: 'center', color: '#8b949e' }}>{vide}</div>;
  return (
    <>
      {titre('À venir')}
      {aVenir.length ? aVenir.map(rendre) : <div style={{ fontSize: 13, color: '#8b949e', marginBottom: 8 }}>Rien de prévu pour le moment.</div>}
      {passes.length > 0 && (<>
        {titre('Passés')}
        {recents.map(rendre)}
        {anciens.length > 0 && (tout
          ? anciens.map(rendre)
          : <button type="button" className="btn btn-secondary" style={{ width: 'auto', padding: '7px 14px', fontSize: 12.5 }} onClick={() => setTout(true)}>
              Voir les plus anciens ({anciens.length})</button>)}
      </>)}
    </>);
}
